import {Injectable} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {BekreftelseDialogKomponent, DialogParametre} from "web-ng2/delt/komponenter/dialog/bekreftelse-dialog/bekreftelse-dialog";
import {firstValueFrom} from "rxjs";
import {map} from "rxjs/operators";

/** Viser standard dialoger.
 * GUI er definert av {@link BekreftelseDialogKomponent} */
@Injectable({providedIn: 'root'})
export class Dialog {

    constructor(private matDialog: MatDialog) {
    }

    info(parametre: DialogParametre): Promise<boolean> {
        return this.håndterDialogrespons(BekreftelseDialogKomponent.visInfo(this.matDialog, parametre))
    }

    advarsel(parametre: DialogParametre): Promise<boolean> {
        return this.håndterDialogrespons(BekreftelseDialogKomponent.visAdvarsel(this.matDialog, parametre))
    }

    fare(parametre: DialogParametre): Promise<boolean> {
        return this.håndterDialogrespons(BekreftelseDialogKomponent.visFare(this.matDialog, parametre))
    }

    // private hjelpemetoder

    håndterDialogrespons(dialog: MatDialogRef<BekreftelseDialogKomponent, boolean>): Promise<boolean> {
        var vedLukk = dialog.afterClosed()
          .pipe(map(klikketPåOk => klikketPåOk ?? false));
        return firstValueFrom(vedLukk)
    }

}
